module.exports = __webpack_public_path__ + "img/settings.d5b785ee.png";